import { render, staticRenderFns } from "./StandardUser.vue?vue&type=template&id=484686bb&"
import script from "./StandardUser.vue?vue&type=script&lang=js&"
export * from "./StandardUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports